import { Icon } from "@vds/icons";
import { DEVICE_STORAGE_NAMES } from "../constants/devices";
import { getTagName } from "../../model/reportService";
export const searchTableRecordByInput = (
  device,
  input,
  tableColumns,
  dataList
) => {
  if (
    tableColumns?.some((item) => {
      if (item === "rulestatus") {
        const data = device.disabled ? "Disabled" : "Enabled";
        return data.toLowerCase().includes(input.toLowerCase());
      }
      if (item === "ruletype") {
        const data = device.systemRule ? "System" : "Custom";
        return data.toLowerCase().includes(input.toLowerCase());
      }
      if (item === "alertstatus") {
        const data = device.iscleared
          ? "Closed"
          : device.isacknowledged && !device.iscleared
          ? "Read"
          : "New";
        return data.toLowerCase().includes(input.toLowerCase());
      }
      if (item === "state") {
        const dd = device[item] === "ready" ? "Online" : "Offline";
        return dd.toLowerCase().includes(input.toLowerCase());
      }
      if (item === "uid") {
        return getLocation(device[item], dataList)
          .toLowerCase()
          .includes(input.toLowerCase());
      }

      if (device.hasOwnProperty(item) && typeof device[item] === "string") {
        return device[item].toLowerCase()?.includes(input?.toLowerCase());
      }
    })
  ) {
    return true;
  }
  // if (device.children) {
  //     return device.children.some( item => searchTableRecordByInput(item, input, tableColumns));
  // }
  return false;
};

export const createSorterForAlertStatus = (a, b) => {
  const status = { Closed: 3, Read: 2, New: 1 };
  return status[
    a.iscleared ? "Closed" : a.isacknowledged && !a.iscleared ? "Read" : "New"
  ] <
    status[
      b.iscleared ? "Closed" : b.isacknowledged && !b.iscleared ? "Read" : "New"
    ]
    ? -1
    : 1;
};

export const getSortedListOfRecords = (recordList, fieldName) => {
  return recordList?.sort((a, b) =>
    a[fieldName]?.toLowerCase() < b[fieldName]?.toLowerCase() ? -1 : 1
  );
};

export const sortAndSetAlertList = (alertList) => {
  return [...alertList.sort(createSorterForAlertStatus)];
};

export const getDeviceDetails = (
  deviceList = [],
  deviceIdOrName,
  prop = ""
) => {
  const property = prop ? prop : "uid";
  return (
    deviceList?.filter((dev) => dev[property] === deviceIdOrName)[0] || null
  );
};

export const getRuleDetails = (ruleList = [], ruleId) => {
  return ruleList?.filter((rule) => rule.id === ruleId)[0] || null;
};

export const getNewAlertList = (alertList) => {
  return [
    ...alertList.filter((item) => !item.isacknowledged && !item.iscleared),
  ];
};

export const getLocation = (uid, deviceList) => {
  let location = "Not Available";
  if (!deviceList || deviceList.length <= 0) return "";
  let list = deviceList.find((device) => device.uid == uid && device?.tagids);
  return list ? getTagName(list.tagids[0], deviceList) : location;
};

export const getCampainFilter = (record, value, parentDeviceList) => {
  {
    const list = getCompanion(record.id, parentDeviceList);
    if (list.length > 0) {
      const companion = list.find((companion) => companion.name === value);
      //If a companion with the matching name is found, return
      if (companion !== undefined) {
        console.log("Found companion:", companion);
        return true;
      }
    }
    return false;
  }
};

export const getFieldOfVisionsFilter = (record, value, parentDeviceList) => {
  {
    const list = getFieldOfVisions(record.id, parentDeviceList);
    if (list.length > 0) {
      const fieldVision = list.find(
        (fieldVision) => fieldVision.name === value
      );
      //If a companion with the matching name is found, return true
      if (fieldVision !== undefined) {
        return true;
      }
    }
    return false;
  }
};

export const getFields = (record, deviceList) => {
  let field = {};
  console.log(record);
  deviceList.filter((device) => {
    if (device.uid === record.id) {
      console.log(device);
      console.log("getFields match found value========");
      console.log(device.fields);
      field = device.fields;
    }
  });
  return field;
};

export const getRecord = (record, deviceList) => {
  let updatedRecord = {};
  deviceList.filter((device) => {
    if (device.uid === record.id) {
      const parentRefid = device.refid;

      updatedRecord = { ...record, parentRefid };
    }
  });
  return updatedRecord;
};
export const getFieldOfVisions = (refid, deviceList) => {
  let id = getCameraObjectbyId(refid)[0]?.id;
  if (id !== null) {
    const matchingChildren = deviceList.filter(
      (item) =>
        item.parentdeviceid === id && item.kind === "ts.device.onvif.fov"
    );
    return matchingChildren;
  }
  return [];
};
export const getCameraObjectbyId = (cameraId) => {
  const cameralist = JSON.parse(
    sessionStorage.getItem(`${DEVICE_STORAGE_NAMES[4]}`)
  );
  const filteredCameras = cameralist?.filter((item) => item.refid === cameraId);
  return filteredCameras;
};

export const getCompanion = (id, deviceList) => {
  if (!deviceList || !Array.isArray(deviceList)) {
    console.error("Device list is not valid");
    return [];
  }

  const foundDevice = deviceList.find((d) => d && d.id === id);

  if (!foundDevice) {
    console.error("Device not found");
    return [];
  }

  const { parentdeviceid } = foundDevice;

  if (parentdeviceid) {
    const kind = "ts.device.gateway.vision.companion";
    if (id !== null) {
      const matchingChildren = deviceList.filter(
        (item) => item.id === parentdeviceid && item.kind.includes(kind)
      );
      return matchingChildren;
    }
  }
  return [];
};

export const getSearchFilterList = (columnDetails, filterKey = "dataIndex") => {
  return columnDetails.reduce((acc, val) => {
    return acc.concat(val[filterKey] || "");
  }, []);
};

export const getMake = (data) => {
  if (data["refid"] === "15020314-0204-0408-1500-ec71db465af7")
    return "ReoLink";
  else if (data["refid"] === "00075fe0-a604-04a6-e05f-0700075fe05f")
    return "Bosch";
  else if (data["refid"] === "00075fca-f8fa-faf8-ca5f-0700075fca5f")
    return "Bosch";
  else if (data["refid"] === "00053234-0029-0127-2919-ec71dbe838cc")
    return "ReoLink";
  else return "ReoLink";
};

export const getModel = (data) => {
  if (data["refid"] === "15020314-0204-0408-1500-ec71db465af7")
    return "E1 Zoom";
  else if (data["refid"] === "00075fe0-a604-04a6-e05f-0700075fe05f")
    return "Flexidome 5000i";
  else if (data["refid"] === "00075fca-f8fa-faf8-ca5f-0700075fca5f")
    return "Flexidome 5000i";
  else if (data["refid"] === "00053234-0029-0127-2919-ec71dbe838cc")
    return "Track";
  else return "E1 Zoom";
};

export const getSortingIcon = (sortOrder, isSmallFont) => {
  const hasActiveSort = sortOrder === "ascend" || sortOrder === "descend";
  let sortIcon = (
    <span className="sasp-table-sort-icon sasp_d-flex">
      {hasActiveSort && (
        <Icon
          name={sortOrder === "ascend" ? "up-arrow" : "down-arrow"}
          size={"small"}
          color="#006FC1"
        />
      )}
    </span>
  );
  return sortIcon;
};

export const getFilterIcon = (filtered, isSmallFont) => (
  <span className="sasp-table-filter-icon sasp_d-flex">
    <Icon
      name="filter"
      size={"small"}
      color={filtered ? "#006FC1" : "#A7A7A7"}
    />
  </span>
);
